import orderBy from 'lodash/orderBy'
const Countries = {
  computed: {
    countries() {
      const countries = require('i18n-iso-countries')
      countries.registerLocale(require('i18n-iso-countries/langs/sv.json'))
      const countryNames = countries.getNames('sv')
      let allCountries = []
      for (const [key, value] of Object.entries(countryNames)) {
        allCountries.push({key, value})
      }
      return orderBy(allCountries, ['value'], ['asc'])
    }
  }
}

export default Countries
